import LocationBaseController from '../common/location.base.controller'

class LocationMissinglatlngController extends LocationBaseController {
  /*@ngInject*/
  constructor(Auth, $state, User, Modal, LocationService, $translate, $stateParams, $scope, $location, SetupService) {

    super(Auth, $state, User, LocationService, Modal, $translate, $stateParams, $location)

    this.id = 'location.all'
    this.loading = false //true
    this.locations = [];
    this.page = 1;
    this.total = 0;
    this.pageLimit = 10;
    this.maxPages = 10;
    this.hasACL = {};
    this.$location = $location;
    this.branch = User.getUser().branchId;
    this.customerId = User.getUser().customerUser ? User.getUser().customerId : null;
    this.SetupService = SetupService;
    this.enableGeoCoding = "";

    this.icon = {
      'REGULAR': 'regular.png',
      'ATM': 'atm.png',
      'BANK': 'bank.png',
      'NO_SHIP_NO_GO': 'nsng.png',
      'INTERNAL': 'internal.png',
      'TRUCK': 'truck.png',
      'TANKER': 'tanker.png',
      'WINDOW': 'window.png',
      'ON_CALL': 'oncall.png',
      'CARRIER': 'carrier.png',
      'LOCKER': 'locker.png',
      'VAULT': 'vault.png',
      'DELIVERY': 'delivery.png'
    }
    this.searchObj = {
      type: '',
      text: ''
    };
    this.locationTypeList = ['', 'DELIVERY', 'ATM', 'Regular', 'Bank', 'ON_CALL', 'LOCKER', 'NO_SHIP_NO_GO', 'Internal', 'Truck', 'Tanker', 'Carrier', 'Window', 'VAULT']
    this.locationTypes = this.locationTypeList.map((list) => {
      if (list == '') {
        return {
          value: '',
          label: $translate.instant('location_types.All')
        };
      }
      return {
        value: list,
        label: $translate.instant('location_types.' + list)
      };
    });
  }
  loadImage = function (image) {
    let imgURL = this.icon[image]
    return require('../../../assets/images/' + imgURL);
  }

  $onInit() {
    let pageId = this.$stateParams.page
    if (pageId > 0) {
      this.page = pageId
    }

    this.SetupService.get(this.branch)
      .then((data) => {
          this.enableGeoCoding = data.enableGeoCoding;
      })
      .then(() => {
        this.loadData();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  edit(location) {
    this.$state.go('location.edit', ({
      id: location.id
    }))
  }

  delete(location) {
    this.Modal.confirm({
      header: this.$translate.instant('common.confirm_delete_title'),
      message: this.$translate.instant('common.confirm_delete_message') + ` <strong>${location.id}</strong>?`,
      callback: (({
        modal,
        $scope
      }) => {
        $scope.loading = true
        this.Service.remove(location.id)
          .then((data) => {
            modal.close()
            this.refresh()
          })
      }),
      type: 'danger'
    })
  }

  refresh() {
    this.loadData()
  }

  pageChange() {
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData();
  }

  loadData() {
    const searchObj = this.generateSearchObj();
    this.loading = true;
    this.Service.getAllLocation(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit)
      .then((data) => {
        this.total = data.total

        this.loading = false
        this.locations = data.results;
      })
      .catch((err) => {
        this.loading = false
        this.error = err.message
      })
  }

  generateSearchObj() {
    let obj = {
      queryJSON: {
        rules: [
          {
            field: 'branchId',
            condition: '=',
            data: this.branch
          },
          {
            group: {
              rules: [
                {
                  field: 'lat',
                  condition: 'IS NULL'
                },
                {
                  field: 'long',
                  condition: 'IS NULL'
                }
              ],
              operator: 'OR'
            }
          },
          {
            group: {
              rules: [
                {
                  field: 'locationType',
                  condition: '!=',
                  data: 'TANKER'
                },
                {
                  field: 'locationType',
                  condition: '!=',
                  data: 'INTERNAL'
                }
              ],
              operator: 'AND'
            }
          }
        ],
        operator: 'AND'
      }
    };

    if (this.customerId) {
      obj.queryJSON.rules.push({
        field: 'customerId',
        condition: '=',
        data: this.customerId
      })
    }
    if (this.searchObj.text) {
      obj.queryJSON.rules.push({
        "group": {
          "rules": [
            {
              "data": "%" + this.searchObj.text + "%",
              "field": "id",
              "condition": "like"
            },
            {
              "data": "%" + this.searchObj.text + "%",
              "field": "name",
              "condition": "like"
            }
          ],
          "operator": "OR"
        }
      });
    }

    if (this.searchObj.type) {
      obj.queryJSON.rules.push({
        field: 'locationType',
        condition: '=',
        data: this.searchObj.type
      });
    }

    return obj.queryJSON.rules.length ? obj : { branch: this.branch };
  }

  search() {
    this.page = 1;
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData();
  }

  toggleExpand(location) {
    location.expand = !location.expand;
  }

  fixGeoCode() {
    this.model.loading = true;
    this.Service.fixGeocoding(this.branch, [])
      .then((data) => {
        this.loadData();
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.model.loading = false;
      })
  }

}

export default LocationMissinglatlngController;


// WEBPACK FOOTER //
// ./client/app/components/location/missinglatlng/location.missinglatlng.controller.js